import React from 'react';
import { Box, Typography } from '@mui/material';
import { LocalizedText } from '../../types/LocalizedText';
import { normalizeLocalizedText } from '../../utils/localizedText';
import { getLanguageFlag } from '../../utils/languageFlags';

interface LocalizedTextDisplayProps {
  value: LocalizedText | string | undefined | null;
  languageCodes: string[];
  hideEmpty?: boolean;
}

export const LocalizedTextDisplay: React.FC<LocalizedTextDisplayProps> = ({
  value,
  languageCodes,
  hideEmpty = false,
}) => {
  const normalized = normalizeLocalizedText(value, languageCodes);
  const entries = languageCodes
    .map((code) => ({ code, text: normalized[code]?.trim() ?? '' }))
    .filter((entry) => !hideEmpty || entry.text);

  if (entries.length === 0) {
    return <Typography variant="body2">-</Typography>;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      {entries.map(({ code, text }) => (
        <Box key={code} sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.5 }}>
          <Typography component="span" variant="body2" aria-hidden="true">
            {getLanguageFlag(code)}
          </Typography>
          <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {text || '-'}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};
